import { useEffect, useState } from 'react';
import { Formik } from 'formik';
import { useTranslation } from 'react-i18next';
import { GraphQLError } from 'graphql';
import * as querystring from 'querystring';
import { useHistory } from 'react-router';
import { useToasts } from 'react-toast-notifications';
import { Box } from 'reflexbox';

import { Button, Callout, Heading, Input, Label } from '@treams/treams-ui';

import BareLayout from 'packages/kakapo-ui-application/layouts/BareLayout';
import PublicForm from 'packages/kakapo-ui-kit/components/forms/layouts/PublicForm';
import GraphQLErrorMessage from 'packages/kakapo-ui-kit/components/forms/errors/GraphQLErrorMessage';
import * as graphql from 'generated/graphql';

export default function ForgotPassword() {
	const { addToast } = useToasts();
	const { t } = useTranslation();
	const history = useHistory();

	const [commit] = graphql.useConfirmForgotPasswordMutation();

	const [error, setError] = useState<GraphQLError | undefined>(undefined);
	const [success, setSuccess] = useState(false);

	const params = querystring.parse(window.location.search.substring(1));

	const [timeoutHandle, setTimeoutHandle] = useState<any>();

	// Make sure that the user isn't redirected after they already manually
	// navigated to another page.
	useEffect(() => {
		return () => clearTimeout(timeoutHandle);
	}, []);

	return (
		<BareLayout>
			<Formik
				initialValues={{
					login: (params['username'] as string) ?? '',
					code: (params['code'] as string) ?? '',
					password: '',
				}}
				onSubmit={async ({ login, code, password }) => {
					try {
						await commit({
							variables: {
								input: {
									username: login,
									confirmationCode: code,
									newPassword: password,
								},
							},
						});

						setSuccess(true);

						addToast(t('common.resetPassword.success'), {
							appearance: 'success',
							autoDismiss: true,
						});

						clearTimeout(timeoutHandle);

						setTimeoutHandle(
							setTimeout(() => {
								history.push('/authentication');
							}, 10000),
						);
					} catch (errors) {
						setError(errors.graphQLErrors[0]);
					}
				}}
			>
				<PublicForm>
					<Heading my={2}>{t('common.resetPassword.title')}</Heading>

					<GraphQLErrorMessage error={error} />

					{success ? (
						<Callout color="employee" description={t('common.resetPassword.success')} />
					) : (
						<>
							<Box mb={3}>
								<Label mb={2}>{t('common.userName')}:</Label>
								<Input.Formik name="login" disabled />
							</Box>

							<Box mb={3}>
								<Label mb={2}>{t('common.code')}:</Label>
								<Input.Formik name="code" disabled />
							</Box>

							<Box mb={3}>
								<Label mb={2}>{t('common.newPassword')}:</Label>
								<Input.Formik name="password" type="password" autoFocus />
							</Box>

							<Button.Formik title={t('common.resetPassword.button')} />
						</>
					)}
				</PublicForm>
			</Formik>
		</BareLayout>
	);
}
